import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-isotype.svg';
import { APIcon } from '@components/atoms/APIcon';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

import { TMerchantProfileProps } from './types';

export const MerchantProfile = ({
  userName,
  isVerified,
  userTag,
  profilePicture,
}: TMerchantProfileProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <div className="bg-white rounded-[100px] overflow-hidden w-[110px] h-[110px] flex justify-center">
          {profilePicture ? (
            <APImage
              img={profilePicture}
              width={110}
              height={110}
              alt={t('AstroPayDownload.title')}
              className="ml-1"
            />
          ) : (
            <APImage
              img={logo}
              width={110}
              height={110}
              alt={t('AstroPayDownload.title')}
              className="ml-1"
            />
          )}
        </div>

        {isVerified && (
          <div className="absolute bottom-0 right-0">
            <APIcon img="checkCircleFill" size={30} />
          </div>
        )}
      </div>
      <div>
        <div>
          <Typography text={userName} weight={500} className="text-[24px] text-center" />
        </div>
        <div>
          <Typography
            text={`@${userTag}`}
            weight={400}
            className="text-[16px] text-center text-[#64748B]"
          />
        </div>
      </div>
    </div>
  );
};
